import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { filter, map, take } from 'rxjs/operators';

/**
 * Guard que protege rotas restritas com base nas permissões ACF do mainframe.
 * Aguarda as permissões serem carregadas (definidas após o acf-check) antes de decidir.
 */
function createMenuPermissionGuard(
  permissionKey: 'canManageManagers' | 'canManageParametros'
): CanActivateFn {
  return () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    return authService.menuPermissions$.pipe(
      filter((permissions): permissions is { canManageManagers: boolean; canManageParametros: boolean } => permissions !== null),
      take(1),
      map(permissions => {
        if (permissions[permissionKey]) {
          return true;
        }
        return router.createUrlTree(['/home']);
      })
    );
  };
}

export const canManageManagersGuard: CanActivateFn = createMenuPermissionGuard('canManageManagers');
export const canManageParametrosGuard: CanActivateFn = createMenuPermissionGuard('canManageParametros');
